import React, { memo } from "react";
import {
  makeStyles,
  TextField,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import {
  Controller,
  useFormContext,
  useController,
  get,
} from "react-hook-form";
import Error from "../Error/Error";
import { white } from "../../constants/colors";
import InputMask from "react-input-mask";

const useStyles = makeStyles((theme) => ({
  inputStyles: {
    width: "100%",
    marginBottom: "10px",

    "& label.Mui-focused, & label.MuiFormLabel-filled": {
      fontSize: "12px",
    },

    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, 9px) scale(0.75) !important",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-marginDense": {
      transform: "translate(14px, 21px) scale(1)",
    },
    "& .MuiOutlinedInput-input": {
      padding: "20px 15px",
    },

    "& .MuiInputBase-root": {
      height: "62px",

      "& input": {
        fontFamily: "sbcBold",
        color: "#282F36",
        fontSize: "16px",
        lineHeight: 1.2,
        marginTop: "10px",
        zIndex: 1,
      },
      "& fieldset": {
        border: "1px solid #D7D7D7",
        borderRadius: "10px",
        top: 0,
        background: white,

        "& legend": {
          display: "none",
        },
      },
    },
  },
}));

const CardTextInput = ({ ...props }) => {
  const { inputStyles } = useStyles();
  const { meta } = useController(props);
  const { control, formState } = useFormContext();
  const error = get(formState.errors, props.name);
  const errorText = meta.invalid ? error.message : "";

  return props.formType === "approve" ?
    (
      <FormControl error={!!errorText} className={inputStyles}>
        <Controller
          {...props}
          as={
            <TextField variant="outlined" size="small" {...props} />
          }
          disabled={false}
          variant="outlined"
          control={control}
          defaultValue={props.defaultValue}
        />
        <FormHelperText>
          {errorText && <Error errorMessage={errorText} />}
        </FormHelperText>
      </FormControl>
    )
    : (
    <FormControl error={!!errorText} className={inputStyles}>
      <Controller
        {...props}
        as={
          <InputMask>
            {(props) => (
              <TextField variant="outlined" size="small" {...props} />
            )}
          </InputMask>
        }
        mask={props.formType === "view" ? "9999 9999 9999 9999" : "9999 9999 9999 9999 999"}
        maskChar={props.formType === "view" ? "●" : " "}
        disabled={false}
        variant="outlined"
        control={control}
        defaultValue={props.defaultValue}
      />
      <FormHelperText>
        {errorText && <Error errorMessage={errorText} />}
      </FormHelperText>
    </FormControl>
  );
};

export default memo(CardTextInput);
